export default __webpack_public_path__ + "static/media/front.6e9f3b23.png";